import http from '../utils/http';
import { interpolate } from 'utils/string';
import { EVENTS, EVENT_URL_ID } from '../constants/endpoints';
import type { Events } from 'interface/events';
import type { ServiceId, ServiceParams } from 'interface/service';

export async function fetchEvents(params: ServiceParams) {
  return await http.get(EVENTS, { params: { ...params } });
}

export async function createEvent(event: Events) {
  return await http.post(EVENTS, { body: event });
}

export async function updateEvent(id: ServiceId, event: Events) {
  return await http.put(interpolate(EVENT_URL_ID, { id }), { body: event });
}

export async function fetchEventById(id: ServiceId) {
  return await http.get(interpolate(EVENT_URL_ID, { id }));
}

export async function removeEvent(id: ServiceId) {
  return await http.delete(interpolate(EVENT_URL_ID, { id }));
}
